import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap"
import Select from "react-select";
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import SelectOptions from "components/SelectOptions"
import AreasService from "services/Admin/AreasService"
import CompoundService from "services/Admin/CompoundService"
import CountriesService from "services/Admin/CountriesService"

const FilterModal = ({ filterModal, setFilterModal, filters,setFilters }) => {
    const areasService= new AreasService()
    const countriesService = new CountriesService()
    const [areaOptions, setAreaOptions] = useState([])
    const [countryOption, setCountryOptions] = useState([])
    const [compoundOptions, setCompoundOptions] = useState([])
    const [filterData, setFilterData] = useState({
        area_ids: null ,
        compound_ids: null,
        country_ids: null
    })

    useEffect(() => {
      setFilterData({...filters})
    }, [])

    useEffect(() => {
        countriesService.getDropDown().then(res => {
            const newOptions = res?.data?.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setCountryOptions(newOptions)
        })
    }, [])

    useEffect(()=>{
        if(!!filterData.country_ids?.value){
            areasService.getAreasDropDown(filterData.country_ids?.value).then(res => {
            const data = res.data?.map(item => {
                return {
                    name: item.name,
                    label: item.name.en,
                    value: item.id
                }
            })
            setAreaOptions(data)
        })
        }
    },[filterData.country_ids])

    return (
        <AvForm className='form-horizontal'>
            <Modal isOpen={filterModal} toggle={() => setFilterModal(!filterModal)}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={() => setFilterModal(!filterModal)}>
                    Sales Filters
            </ModalHeader>
                <ModalBody>
                <Col md={12}>
                    <label>Countries</label>
                    <Select
                        placeholder={"Select"}
                        options={countryOption}
                        onChange={(data) => {
                            setFilterData({...filterData, country_ids: data, area_ids: null})
                        }}
                        value={filterData.country_ids}
                    />
                </Col>
                <Col md={12} className='mt-3'>
                    <label>Location</label>
                    <Select
                        placeholder={"Select"}
                        options={areaOptions}
                        noOptionsMessage={() => {
                            if(!filterData.country_ids?.label){
                                return "Choose Country First"
                            }
                        }}
                        onChange={(data) => {
                            setFilterData({ ...filterData, area_ids:data })
                        }}
                        value={filterData.area_ids}
                        isMulti={true}
                    />
                </Col>
                    <Col md={12} className='mt-3'>
                        <SelectOptions
                            label='Compound'
                            placeholder='Select'
                            options={compoundOptions}
                            handleSelectChange={(data) => {
                                setFilterData({ ...filterData, compound_ids: data });
                            }}
                            selectedOption={filterData.compound_ids}
                            Service={CompoundService}
                            setOptions={(options) => {
                                setCompoundOptions(options)
                            }}
                            isMulti={true}
                        />
                    </Col>
                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button type='button'      className='btn btn-light w-120'
                    onClick={() => {
                        setFilterData({ area_ids: null  ,compound_ids:null, country_ids: null})
                        setFilters({
                            area_ids:null,
                            compound_ids:null, 
                            country_ids:null
                        })
                    }}>
                        Reset Filter
                                 </button>
                    <button type='button' onClick={() => {
                        setFilterModal(false)
                        setFilters({...filterData})
                    }} className='btn btn-success  w-120'>
                        Apply Filter
                               </button>
                </ModalFooter>
            </Modal>
        </AvForm>

    )
}
export default FilterModal